import { render, staticRenderFns } from "./center_home.vue?vue&type=template&id=33bd727e&scoped=true&"
import script from "./center_home.vue?vue&type=script&lang=js&"
export * from "./center_home.vue?vue&type=script&lang=js&"
import style0 from "./center_home.vue?vue&type=style&index=0&id=33bd727e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd727e",
  null
  
)

export default component.exports